import Vue from 'vue';
import displayDateTimeRange from '@/filters/displayDateTimeRange';
import makeSrc from '@/filters/makeSrc';
import displayType from '@/filters/displayType';

Vue.filter('displayDateTimeRange', displayDateTimeRange);
Vue.filter('makeSrc', makeSrc);
Vue.filter('displayType', displayType);
